import axios from 'axios';
import { TEST_X_API_KEY } from '../utils/authentication';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/ledmodulestore/api/${apiVersion}`;
if (process.env.NODE_ENV !== 'production') {
  apiUrl = `http://dev.tuner4tronic.com/ledmodulestore/api/${apiVersion}`;
}

const ledmodulesAction = "modules";

function getApiBaseUrl() {
    return apiUrl;
}

export function postLoginApiUrl() {
    return `/`;
}

const instance = axios.create({
    baseURL: `${getApiBaseUrl()}/${ledmodulesAction}`,
    timeout: 30000,
    headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
    config.headers['X-API-KEY'] = localStorage.getItem(TEST_X_API_KEY);
    return config;
});

export default instance;